import { DataArray, IDataArray, Annotation, DeviceDocument } from './../../shared/index';

import { parseUtcAsLocal } from "app/shared/utils/date-utils";

export class Document implements IDataArray {
    public Id: number;
    public FileName: string;
    public VersionDate: Date;
    public RepositoryId: string;
    public RepositoryUrl: string;
    public MetadataId: number;
    public ProductName: string;
    public Updated: Date;
    public Publishing: boolean;
    public UpdateToId: number = null;
    public Version: string;
    public AllowPrinting: boolean;

    public UpdateTo: Document = null;

    public Match: string[] = ['fa-ban', 'fa-ban', 'fa-ban', 'fa-ban', 'fa-ban'];
    public Color: string[] = ['bg-danger', 'bg-danger', 'bg-danger', 'bg-danger', 'bg-danger'];

    public Annotations: DataArray<Annotation> = new DataArray<Annotation>(1);

    public EquipmentCount = 0;
    public Selected = false;
    public GetById(): number {
        return this.Id;
    }

    public DeviceDocuments: DeviceDocument[] = [];

    get VersionCreatedDate(): string {
        return this.VersionDate ? (this.VersionDate.toLocaleDateString() +  ' ' +this.VersionDate.toLocaleTimeString()) : '';
    }

     get LastUpdated(): string {
        return this.Updated ? (this.Updated.toLocaleDateString() +  ' ' +this.Updated.toLocaleTimeString()) : '';
    }

    constructor(data?: Partial<Document>) {
    Object.assign(this, data);
    if (data?.VersionDate) {
      this.VersionDate = parseUtcAsLocal(data.VersionDate);
    }

    if (data?.Updated) {
      this.Updated = parseUtcAsLocal(data.Updated);
    }
  }
}
